var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 7.5h2v9h-2v-9z",
    fill: "#4A5056",
    stroke: "#4A5056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.25h3V17H2v-3.75z",
    fill: "#4A5056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 16.5v-5.875h2V16.5h-2z",
    fill: "#4A5056",
    stroke: "#4A5056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A5056",
    d: "M15.5 3h3v14h-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.d4e535704754e472b2d2445cce5ba017.svg";
export { ForwardRef as ReactComponent };